import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet.polyline.snakeanim";

export default function AnimatedPolyline({ map, coords, options }) {
  const line = useRef();

  const init = () => {
    line.current = L.polyline(coords, { ...options, snakingSpeed: 700 });
    line.current.addTo(map).snakeIn();
  };

  useEffect(() => {
    if (!map) return;
    init();

    return () => {
      line.current.removeFrom(map);
    };
  }, [map]);

  return <div></div>;
}
